import React, { ReactElement } from "react";
import * as styles from "./EmotionalLauncher.module.scss";
import NativeHeroImage from "components/NativeHeroImage/NativeHeroImage";
import {
  BlockContentValue,
  PartialSanityImageType,
  SectionContainer
} from "@silversea-ssc/ui-components-react";
import { BlockContent } from "components/BlockContent";
import clsx from "clsx";
import type { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens";

export type EmotionalLauncherVariant = "full" | "boxed" | "rounded";

type Props = {
  backgroundImage: PartialSanityImageType | undefined;
  title: string | BlockContentValue;
  subTitle?: ReactElement;
  content: BlockContentValue | undefined;
  dataContentName?: string;
  variant?: EmotionalLauncherVariant;
  tokens?: TokenValues;
};

const EmotionalLauncher: React.FC<React.PropsWithChildren<Props>> = ({
  backgroundImage,
  title,
  content,
  subTitle,
  dataContentName = "emotional_launcher_section",
  variant = "full",
  children,
  tokens
}) => {
  const isTitleString = typeof title === "string";
  return (
    <div
      className={clsx(styles.slide, {
        [styles.variantBoxed]: variant == "boxed",
        [styles.variantRounded]: variant == "rounded"
      })}
      data-content-name={dataContentName}
    >
      <div className={styles.slideBackground}>
        {backgroundImage && (
          <NativeHeroImage
            image={backgroundImage}
            alt={isTitleString ? title : ""}
            lazyload
          />
        )}
      </div>

      <React.Fragment>
        <SectionContainer
          wrapperClassName={styles.boxWrapper}
          backgroundColor="transparent"
        >
          <div
            className={clsx(styles.box, {
              [styles.variantRounded]: variant == "rounded"
            })}
          >
            {isTitleString && <h4 className={styles.title}>{title}</h4>}
            {!isTitleString && (
              <h4 className={styles.title}>
                <BlockContent value={title} tokens={tokens} />
              </h4>
            )}
            {subTitle}
            <div className={styles.content}>
              <BlockContent value={content} tokens={tokens} />
            </div>
            {children}
          </div>
        </SectionContainer>
      </React.Fragment>
    </div>
  );
};

export default EmotionalLauncher;
